import { getBankFees } from "@/services/bankFeeService";
import { useQuery } from "react-query";

export const useBankFee = (queryKey: string) => {
  return useQuery({
    queryKey: [queryKey],
    queryFn: getBankFees,
  });
};
